import LanguageUtils from "../../../../util/LanguageUtils"
import {AvantColors} from "../../../../styles/AvantColors"
import {H5Text} from "../../../../styles/AvantTypography"
import * as React from "react"

export const LanguageBar = (props: { language: string }) => {
    const language = LanguageUtils.removeTilde(props.language)

    return <H5Text sx={{
        backgroundColor: AvantColors.REPORT_BACKGROUND_GRAY_DARK,
        height: "36px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "6px"
    }}>{language}</H5Text>
}